import { KEY_SEPARATOR } from './table.constants';
import { TPermissionRecord, TScopeRecord, TTableColumn } from './table.types';

export const isPermissionRecord = (entity: TPermissionRecord | TScopeRecord): entity is TPermissionRecord =>
  (entity as TPermissionRecord).roles !== undefined;

export const isScopeRecord = (entity: TPermissionRecord | TScopeRecord): entity is TScopeRecord =>
  (entity as TScopeRecord).children !== undefined;

export const isAllPermissionEnabled = (scope: TScopeRecord, column: TTableColumn): boolean =>
  scope.children.every((permission) => permission.roles[column.key]);

export const isAllPermissionDisabled = (scope: TScopeRecord, column: TTableColumn): boolean =>
  scope.children.every((permission) => !permission.roles[column.key]);

export const isIndeterminate = (record: TScopeRecord | TPermissionRecord, column: TTableColumn): boolean => {
  if (!isScopeRecord(record)) {
    return false;
  }
  return !isAllPermissionEnabled(record, column) && !isAllPermissionDisabled(record, column);
};

export const isScopeCheckboxKey = (key: string): boolean => {
  const [, , permissionKey] = key.split(KEY_SEPARATOR);
  return !permissionKey;
};
